import { Column } from "data/table.data";
import {
  BusinessWithPaymentNoticeCount,
  formatPaymentNoticeAmount,
  PaymentNoticeMatchStatus,
  PAYMENT_NOTICE_MATCH_STATUS_LABELS
} from "models/paymentNotice.model";
import {
  convertDate,
  convertMobileNo,
  convertRegNumber
} from "utils/converter";
import { renderDateTime } from "utils/renderer";

export const BUSINESS_LIST_COLS: Column[] = [
  { id: "incharge", label: "담당자", sorting: true, sx: { width: 72 } },
  {
    id: "name",
    label: "사업자명",
    sorting: true,
    sx: { width: 160, wordBreak: "break-all" }
  },
  {
    id: "regNumber",
    label: "사업자등록번호",
    sorting: true,
    sx: { width: 144, whiteSpace: "nowrap" },
    renderer: (data) => convertRegNumber(data.regNumber)
  },
  {
    id: "nationalTaxCount",
    label: "국세",
    sorting: true,
    sx: { width: 80, textAlign: "right" },
    renderer: (data) => `${data.nationalTaxCount}건`
  },
  {
    id: "localTaxCount",
    label: "지방세",
    sorting: true,
    sx: { width: 80, textAlign: "right" },
    renderer: (data) => `${data.localTaxCount}건`
  },
  {
    id: "taxReceiptCount",
    label: "접수증",
    sorting: true,
    sx: { width: 80, textAlign: "right" },
    renderer: (data) => `${data.taxReceiptCount}건`
  },
  {
    id: "otherCount",
    label: "기타",
    sorting: true,
    sx: { width: 80, textAlign: "right" },
    renderer: (data) => `${data.otherCount}건`
  },
  {
    id: "totalCount",
    label: "합계",
    sorting: true,
    sx: { width: 90, textAlign: "right", fontWeight: 600 },
    renderer: (data) => `${data.totalCount}건`
  },
  {
    // kakaoMobileNo(= 급여담당자 연락처 payrollManagerMobileNo)만 쓰기 가능이라 편집 대상으로 잡는다.
    // 없으면 userMobileNo를 읽기용으로 보여주되, 새로 입력하는 값은 항상 kakaoMobileNo로 등록된다.
    id: "kakaoMobileNo",
    label: "휴대폰 번호",
    sorting: true,
    sx: { width: 130, whiteSpace: "nowrap" },
    renderer: (data: BusinessWithPaymentNoticeCount) => {
      const mobileNo = data.kakaoMobileNo || data.userMobileNo;
      return mobileNo ? convertMobileNo(mobileNo) : "-";
    },
    input: {
      format: (value) => value.replace(/[^0-9]/g, ""),
      width: 100,
      submit: () => {}
    }
  },
  {
    id: "kakaoSentAt",
    label: "카카오톡 발송일시",
    sorting: true,
    sx: { width: 120, textAlign: "right" },
    renderer: (data: BusinessWithPaymentNoticeCount) =>
      renderDateTime(data.kakaoSentAt)
  }
];

export const BUSINESS_PAYMENT_NOTICE_LIST_COLS: Column[] = [
  { id: "originalFileName", label: "파일명" },
  { id: "taxItem", label: "세목", sx: { width: 140 } },
  { id: "period", label: "귀속기간", sx: { width: 100 } },
  {
    id: "dueDate",
    label: "납부기한",
    sx: { width: 110 },
    renderer: (data) => (data.dueDate ? convertDate(data.dueDate) : "-")
  },
  {
    id: "amount",
    label: "금액",
    sx: { width: 130, textAlign: "right" },
    renderer: (data) => formatPaymentNoticeAmount(data)
  },
  {
    id: "matchStatus",
    label: "매칭 상태",
    sx: { width: 140 },
    renderer: (data) =>
      PAYMENT_NOTICE_MATCH_STATUS_LABELS[
        data.matchStatus as PaymentNoticeMatchStatus
      ]
  },
  {
    id: "createdDate",
    label: "업로드일",
    sx: { width: 110 },
    renderer: (data) => convertDate(data.createdDate)
  }
];
